module.exports = ".text {\r\n    color: rgba(0, 0, 0, 0.54);\r\n    margin-bottom: -12px;\r\n}\r\n\r\n.icon {\r\n    font-size: 4.375em;\r\n    color: rgba(0, 0, 0, 0.54);\r\n    margin-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pages/error/unauthorized-page.component.css
// module id = ./src/app/shared/pages/error/unauthorized-page.component.css
// module chunks = main